import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { Subscription } from 'rxjs';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { element } from 'protractor';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  @Input() dataCat: any;
  @Input() dataFeatures: any;
  @Input() type: string;
  dataObject: any = [];
  mydata: any = [];

  constructor(private _store: Store<AppState>) {}

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.setSubscriptions();
  }

  /**
   * -------------------------------------------------------
   * @summary carouselCatalogConfig
   * @description Configuracion del carousel
   * -------------------------------------------------------
   */
  carouselCatalogConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    cssEase: 'linear',
    fade: false,
    autoplay: true,
    autoplaySpeed: 4000,
    draggable: true,
  };

  /**
   * -------------------------------------------------------
   * @summary setSubscriptions
   * @description Traer el valor del state del estado del translated de redux
   * -------------------------------------------------------
   */
  setSubscriptions() {
    this._subscription.add(
      this._store.select('layout').subscribe((state) => {
        setTimeout(() => {
          if (this.type === 'catalogs_mobile') {
            this.asignColorCarouselProduct(state.setcolor);
          }
        }, 100);
      })
    );
  }

  /**
   * -------------------------------------------------------
   * @summary asignColorCarouselProduct
   * @description Llena los cards de cada categoria de porducto con el parametro recibido desde redux
   * -------------------------------------------------------
   */
  asignColorCarouselProduct(color: string) {
    if (this.type === 'catalogs_mobile' && this.dataCat !== undefined) {
      if (color !== undefined) {
        let elecat = document.getElementsByClassName('divProdCatcar');
        // console.log(`elecat`, elecat)
        setTimeout(() => {
          if (elecat.length > 0) {
              let elementPos = elecat;
              let numberColor = this.dataCat.background.split('-')[1];
              for (let index = 0; index < elecat.length; index++) {
                elementPos[index].classList.add('bgsigmaprodcatcar-' + numberColor);
              }
          }
        }, 100);
      }
    }
  }

  /**
   * -------------------------------------------------------
   * @summary next
   * @description Boton Next Slide Carousel
   * -------------------------------------------------------
   */
  next() {
    this.slickModal.slickNext();
  }

  /**
   * -------------------------------------------------------
   * @summary prev
   * @description Boton Prev Slide Carousel
   * -------------------------------------------------------
   */
  prev() {
    this.slickModal.slickPrev();
  }

  /**
   * -------------------------------------------------------
   * @summary ngOnDestroy
   * @description  Destruye conexiones abiertas
   * -------------------------------------------------------
   */
  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
